import _extends from "@babel/runtime/helpers/extends";
import { useForm } from "@mantine/form";
import React, { useEffect, useState } from "react";
import { Button, Checkbox, Radio, PhoneInput, Input, Grid, DateInput } from "../..";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var scrollToFirstError = () => {
  setTimeout(() => {
    var errorMessage = document.querySelector(".text-red-400");

    if (errorMessage && errorMessage.scrollIntoView) {
      errorMessage.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
    }
  }, 0);
};

export var CallbackForm = props => {
  var {
    chat_name,
    callback_intro_text,
    callback_terms_conditions,
    start_time,
    end_time
  } = props;
  var [loading, setLoading] = useState(false);
  var [unexpectedError, setUnexpectedError] = useState(false);
  var [formSuccess, setFormSuccess] = useState(false);
  var form = useForm({
    initialValues: {
      first_name: "",
      last_name: "",
      phone: "61",
      phone_alternate: "61",
      identity: "",
      message: "",
      alternate_person: "",
      recording: "",
      caller_id: "",
      call_date: "",
      privacy_policy: callback_terms_conditions ? "" : true
    },
    validate: {
      first_name: value => /\w/.test(value) ? null : "This field is required.",
      last_name: value => /\w/.test(value) ? null : "This field is required.",
      phone: value => {
        if (!/^\+?61/.test(value)) return "An Australian number is required";
        if (!/^\+?[0-9]{3,14}$/.test(value)) return "This field is required.";
        return null;
      },
      identity: value => /\w/.test(value) ? null : "This field is required.",
      message: value => /\w/.test(value) ? null : "This field is required.",
      alternate_person: value => /\w/.test(value) ? null : "This field is required.",
      recording: value => value ? null : "This field is required.",
      caller_id: value => value ? null : "This field is required.",
      call_date: value => /\w/.test(value) ? null : "This field is required.",
      privacy_policy: value => value ? null : "This field is required."
    }
  });
  useEffect(() => {
    sessionStorage.setItem("callback_form_values", JSON.stringify(form.values));
  }, [...Object.values(form.values)]);
  useEffect(() => {
    var values = sessionStorage.getItem("callback_form_values");
    if (values) form.setValues(JSON.parse(values));
  }, []);

  var onSubmit = () => {
    setUnexpectedError(false);
    form.validate();

    if (!form.isValid()) {
      scrollToFirstError();
      return;
    }

    setLoading(true);
    var {
      first_name,
      last_name,
      phone,
      phone_alternate,
      identity,
      message,
      alternate_person,
      call_date
    } = form.values;
    fetch("https://prod-01.australiaeast.logic.azure.com:443/workflows/4de7cf13b7814e4085415005274e263e/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=TGGsah2wNyTVNE8zamXOAREl7GHvxpeo565R6BQBR1E", {
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json"
      }),
      method: "POST",
      body: JSON.stringify({
        entry: {
          callbackNumbers: [phone, phone_alternate],
          callbackScheduledTime: call_date,
          callbackUserName: first_name + " " + last_name,
          data: {
            source: "Webchat Callback",
            notes: "By " + first_name + " " + last_name + ".\n                    Leave Message? " + message + ".\n                    Identify as " + chat_name + "? " + identity + ".\n                    Speak/leave message with other? " + alternate_person + ".",
            script: "" + identity[0] + message[0] + alternate_person[0]
          }
        },
        eventType: "webchat-callback",
        sourceIdentifier: "createwebchatcallback-webform-h3jfhdna"
      })
    }).then(response => {
      if (response.status !== 200) {
        setUnexpectedError(true);
      }

      setFormSuccess(true);
    }).catch(error => {
      process.env.NEXT_PUBLIC_VERCEL_ENV === "development" && console.error(error);
      setUnexpectedError(true);
    }).finally(() => setLoading(false));
  };

  if (formSuccess) return /*#__PURE__*/_jsx("p", {
    className: "text-green-800",
    children: "Thank you for submitting the form. We will get in contact with you as soon as possible."
  });
  if (loading) return /*#__PURE__*/_jsx("p", {
    children: "Loading..."
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [callback_intro_text && /*#__PURE__*/_jsx("article", {
      children: callback_intro_text
    }), /*#__PURE__*/_jsx("form", {
      id: "callback",
      autoComplete: "on",
      children: /*#__PURE__*/_jsxs(Grid, {
        gap: "4",
        children: [/*#__PURE__*/_jsx(Input, _extends({
          type: "text"
        }, form.getInputProps("first_name"), {
          autoComplete: "given-name",
          children: "First Name"
        })), /*#__PURE__*/_jsx(Input, _extends({
          type: "text"
        }, form.getInputProps("last_name"), {
          autoComplete: "family-name",
          children: "Last Name"
        })), /*#__PURE__*/_jsx(PhoneInput, _extends({}, form.getInputProps("phone"), {
          children: "Contact Number"
        })), /*#__PURE__*/_jsx(PhoneInput, _extends({}, form.getInputProps("phone_alternate"), {
          children: "Alternate contact Number"
        })), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("p", {
            className: "mb-2 text-base",
            children: "Can our team member identify as calling from " + chat_name + "?"
          }), /*#__PURE__*/_jsx(Radio, _extends({}, form.getInputProps("identity"), {
            items: [{
              value: "yes",
              label: "Yes"
            }, {
              value: "no",
              label: "No"
            }],
            name: "identity"
          }))]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("p", {
            className: "mb-2 text-base",
            children: "Can the " + chat_name + " team member leave a message?"
          }), /*#__PURE__*/_jsx(Radio, _extends({}, form.getInputProps("message"), {
            items: [{
              value: "yes",
              label: "Yes"
            }, {
              value: "no",
              label: "No"
            }],
            name: "message"
          }))]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("p", {
            className: "mb-2 text-base",
            children: "Can the " + chat_name + " team member speak with or leave a message with\n            another person?"
          }), /*#__PURE__*/_jsx(Radio, _extends({}, form.getInputProps("alternate_person"), {
            items: [{
              value: "yes",
              label: "Yes"
            }, {
              value: "no",
              label: "No"
            }],
            name: "alternate_person"
          }))]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("p", {
            className: "mb-2 text-base",
            children: chat_name + " Callbacks are recorded for\n            training and supervision purposes"
          }), /*#__PURE__*/_jsx(Checkbox, _extends({}, form.getInputProps("recording", {
            type: "checkbox"
          }), {
            id: "recording",
            error: form.errors.recording,
            children: "I accept"
          }))]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("p", {
            className: "mb-2 text-base",
            children: chat_name + " Callbacks display no caller ID"
          }), /*#__PURE__*/_jsx(Checkbox, _extends({
            required: true
          }, form.getInputProps("caller_id", {
            type: "checkbox"
          }), {
            id: "caller_id",
            error: form.errors.caller_id,
            children: "I accept"
          }))]
        }), /*#__PURE__*/_jsx(DateInput, _extends({}, form.getInputProps("call_date"), {
          startTime: +start_time,
          endTime: +end_time,
          children: "Preferred callback date and time"
        })), callback_terms_conditions && /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("article", {
            className: "[&>*]:text-sm mt-4",
            children: callback_terms_conditions
          }), /*#__PURE__*/_jsx(Checkbox, _extends({}, form.getInputProps("privacy_policy", {
            type: "checkbox"
          }), {
            id: "privacy_policy",
            error: form.errors.privacy_policy,
            children: "I accept"
          }))]
        }), unexpectedError && /*#__PURE__*/_jsx("p", {
          className: "text-red-400 mb-4 text-base",
          children: "Sorry an unexpected error occurred please try again"
        }), /*#__PURE__*/_jsx(Button, {
          color: "tertiary",
          width: "fit-content",
          onClick: e => {
            e.preventDefault();
            onSubmit();
          },
          children: "Submit"
        })]
      })
    })]
  });
};
//# sourceMappingURL=callback_form.js.map